/**
 * #44 — CSRF helper.
 *
 * The backend issues a non-httpOnly `csrf_token` cookie at login + refresh
 * + password-change. The double-submit middleware on every state-changing
 * request requires the cookie value to be echoed in `X-CSRF-Token`.
 * Same Origin Policy keeps cross-site JS from reading our cookie, so an
 * attacker can attach the auth cookies to a forged request but cannot
 * forge the matching header.
 */

const CSRF_COOKIE_NAME = 'csrf_token';

export function readCsrfToken(): string | null {
  if (typeof document === 'undefined') return null;
  const prefix = `${CSRF_COOKIE_NAME}=`;
  const parts = document.cookie ? document.cookie.split(';') : [];
  for (const raw of parts) {
    const part = raw.trim();
    if (part.startsWith(prefix)) {
      return decodeURIComponent(part.slice(prefix.length));
    }
  }
  return null;
}

const CSRF_REQUIRED_METHODS = new Set(['POST', 'PUT', 'PATCH', 'DELETE']);

export function shouldAttachCsrf(method?: string): boolean {
  if (!method) return false;
  return CSRF_REQUIRED_METHODS.has(method.toUpperCase());
}
